import { lazy } from "react";
import { FormattedMessage } from "react-intl";
import { Archive } from "react-feather";

import { Module } from "../../types";

import StudyMaterialWrapper from "./components/StudyMaterialWrapper";

const StudyMaterialPage = lazy(() => import("./pages/StudyMaterialPage"));

export default {
  route: {
    path: "/study-material",
    element: <StudyMaterialWrapper />,
    children: [
      {
        path: "/study-material",
        index: true,
        element: <StudyMaterialPage />,
      },
    ],
  },
  allowed: (userView) => !!userView.modules.studyMaterial,
  name: <FormattedMessage id="module.study-material.name" defaultMessage="Study materials" />,
  icon: <Archive />,
} satisfies Module;
